import { all, call, put, select, takeLatest } from "redux-saga/effects";
import { FETCH_AGENT_ANALYTIC, fetchAgentAnalyticSuccess, fetchAgentAnalyticRequested, fetchAgentAnalyticFailure } from "../actions/agent-analytics-action-types";
import httpClient from "./http-client";

export function* fetchAgentAnalyticHandler({ payload }) {
  yield put(fetchAgentAnalyticRequested());
  const agent = yield select((state) => state?.user?.user?.identifier);
  const request = {
    method: "GET",
    params: {
      agentId: agent, startDate: new Date("01/01/2020").getTime(), endDate: new Date(payload.year, payload.month + 1, 0).getTime(),
    },
    url: "/api/v1/properties/agent-customer",
  };

  const {
    data, error,
  } = yield call(httpClient, request);

  if (error) {
    yield put(fetchAgentAnalyticFailure(data));
  } else {
    yield put(fetchAgentAnalyticSuccess(data.details));
  }
}

function* AgentAnalytic() {
  yield all([
    takeLatest(FETCH_AGENT_ANALYTIC, fetchAgentAnalyticHandler),
  ]);
}

export default AgentAnalytic;
